import { Card } from 'corso-admin-ui';
import { ComponentProps } from 'react';
import { SettingsAnchor } from '~/features/settings/settingsSearchConfig';

export default function SettingsAnchorCard({
  id,
  ...props
}: Omit<ComponentProps<typeof Card>, 'id'> & {
  id: SettingsAnchor;
}) {
  // oxlint-disable-next-line react/jsx-props-no-spreading
  return <Card id={id} {...props} />;
}
